module.exports = __webpack_public_path__ + "static/media/References.d9397fdf.pdf";